import { put, select, take, takeLatest } from "typed-redux-saga";
import { Action } from "typescript-fsa";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { ApplicationActions } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { getLatestSDManifestByAppId } from "../../../app/slices/stammdaten/selectors";
import { DocumentReference } from "../../../utilities/documentReference";

import { STAMMDATEN_MODEL_SUFFIX } from "../constants";
import { openStammdatenAction, OpenStammdatenPayload } from "../actions";

function appIdFromStammdatenModel(model: string): string {
	return model.endsWith(STAMMDATEN_MODEL_SUFFIX) ? model.slice(0, -STAMMDATEN_MODEL_SUFFIX.length) : model;
}

export function* openStammdatenSaga() {
	yield* takeLatest(openStammdatenAction, function* handleOpenStammdaten(action: Action<OpenStammdatenPayload>) {
		const documentReference = DocumentReference.fromString(action.payload.docRef);
		const appId = appIdFromStammdatenModel(documentReference.model);
		const latestManifest = yield* select(getLatestSDManifestByAppId(appId));
		const model = latestManifest?.models.mainDocumentModelId ?? documentReference.model;

		yield* put(ApplicationActions.startMainActivityRequested({ descriptor: { model } }));

		//Wait for Stammdaten Overview to load data before pushing the new activity
		const mainActivityData = yield* take(ActivityActions.loadData);
		yield* put(
			ActivityActions.create({
				initiatingActivityId: mainActivityData.payload.activityId,
				activityDescriptor: { instance: action.payload.docRef, model: documentReference.model }
			})
		);
	});
}
